var WDN = WDN || {};

if (typeof WDN.Announcementbar === "undefined") {
  WDN.Announcementbar = (function () {
    var init, setHeightVariable;

    // handlers
    var handleWindowResize;

    // dependencies
    var CSSVariable = WDN.CSSVariable;

    // nodes
    var nodes = {
      announcementbar: document.querySelector("[data-announcement-bar]"),
    };

    setHeightVariable = function (newValue) {
      if (typeof newValue === "undefined") return;
      CSSVariable.set({
        name: "--announcement-height",
        value: newValue,
      });
    };

    handleWindowResize = function () {
      setHeightVariable(nodes.announcementbar.getBoundingClientRect().height + "px");
    };

    init = function () {
      if (!nodes.announcementbar) {
        setHeightVariable("0px");
        return;
      }

      setHeightVariable(nodes.announcementbar.getBoundingClientRect().height + "px");

      // Event coming from main.js
      window.addEventListener("window:resize", handleWindowResize);
    };

    init();
    return {};
  })();
}
